import businessGroupActionTypes from '../types/businessGroupActionTypes';

const initialState = {
    businessGroups: [],
    selectedBusinessGroup: null,
    stateInfo: {
        isLoading: false,
        isSuccess: false,
        isError: false,
        error: null,
        action:null
    }
};

const businessGroupReducer = (state = initialState, action) => {
    switch (action.type) {
        case businessGroupActionTypes.START_ADD_BUSINESS_GROUP:
        case businessGroupActionTypes.START_DELETE_BUSINESS_GROUP:
        case businessGroupActionTypes.START_UPDATE_BUSINESS_GROUP:
        case businessGroupActionTypes.START_GET_BUSINESS_GROUP:
       
            return {
                ...state,
                stateInfo: {
                    ...state.stateInfo,
                    isLoading: true,
                    isSuccess: false,
                    isError: false,
                    error: null
                }
            };
        case businessGroupActionTypes.ADD_BUSINESS_GROUP_SUCCESS:
        case businessGroupActionTypes.UPDATE_BUSINESS_GROUP_SUCCESS:
        case businessGroupActionTypes.DELETE_BUSINESS_GROUP_SUCCESS:
            return {
                ...state,
                stateInfo: {
                    ...state.stateInfo,
                    isLoading: false,
                    isSuccess: true,
                    isError: false,
                    action:action.action
                }
            };
        case businessGroupActionTypes.GET_BUSINESS_GROUPS_SUCCESS:
            return {
                ...state,
                businessGroups: action.payload,
                  stateInfo: {
                    ...state.stateInfo,
                    isLoading: false
                }
            };
        case businessGroupActionTypes.GET_BUSINESS_GROUPS_FAILURE:
       
            return {
                ...state,
                  stateInfo: {
                    ...state.stateInfo,
                    isLoading: false
                }
            };
        case businessGroupActionTypes.SELECT_BUSINESS_GROUP:
            return {
                ...state,
                selectedBusinessGroup: action.payload
            };
        
        case businessGroupActionTypes.UNSELECT_BUSINESS_GROUP:
            return {
                ...state,
                selectedBusinessGroup: initialState.selectedBusinessGroup
            };
        case businessGroupActionTypes.RESET:
            return initialState;
        case businessGroupActionTypes.ADD_BUSINESS_GROUP_FAILURE:
        case businessGroupActionTypes.UPDATE_BUSINESS_GROUP_FAILURE:
        case businessGroupActionTypes.DELETE_BUSINESS_GROUP_FAILURE:
      
            return {
                ...state,
                stateInfo: {
                    ...state.stateInfo,
                    isLoading: false,
                    isSuccess: false,
                    isError: true,
                    error: action.payload,
                    action: action.action
                }
            };
        case businessGroupActionTypes.RESET_STATE_INFO:
            return {
                ...state,
                stateInfo: initialState.stateInfo
            };
        case "LOGOUT":
            return initialState;
        default:
            return state;
    }
};



export default businessGroupReducer;